export enum MegaMenuProductDiscovery
{
    Variation1 = "variation_1",
    Variation2 = "variation_2",
    Variation3 = "variation_3",
    Variation4 = "variation_4"
}